import { CoreDataDictionaryViewsName } from './name';
import { getDataDictionaryViews } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreDataDictionaryViewsAsyncSlice = createGetAsyncSlice({
	name: CoreDataDictionaryViewsName,
	receive: true,
	request: true,
	requestHandler: getDataDictionaryViews,
	yieldType: SagaYieldType.Latest
});
